import { render, staticRenderFns } from "./InformationClan.vue?vue&type=template&id=17b1af26&"
import script from "./InformationClan.vue?vue&type=script&lang=js&"
export * from "./InformationClan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports